module.exports = __webpack_public_path__ + "img/call.bd29b96f.png";